// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .purejscarousel {
  overflow: hidden;
}

.kore-chat-window .purejscarousel-slides-container:before,
.kore-chat-window .purejscarousel-slides-container:after {
  content: "";
  display: table;
}

.kore-chat-window .purejscarousel-slides-container:after {
  clear: both;
}

.kore-chat-window .purejscarousel-slide {
  float: left;
}

.kore-chat-window .purejscarousel-btn {
  background: transparent;
  border: 0;
  box-shadow: none;
  outline: none;
  cursor: pointer !important;
  height: 20px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 20px;
}

.kore-chat-window .purejscarousel-btn-next {
  border-bottom: 8px solid #aaa;
  border-right: 8px solid #aaa;
  right: 5px;
  -moz-transform: rotate(315deg);
  -webkit-transform: rotate(315deg);
  transform: rotate(315deg);
}

.kore-chat-window .purejscarousel-btn-prev {
  border-bottom: 8px solid #aaa;
  border-left: 8px solid #aaa;
  left: 5px;
  -moz-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.kore-chat-window .purejscarousel-dots-container {
  float: left;
  margin-top: 15px;
  text-align: center;
  width: 100%;
}

.kore-chat-window .purejscarousel-dot {
  background: #aaa;
  border: 0;
  border-radius: 50%;
  box-shadow: none;
  cursor: pointer;
  height: 15px;
  outline: none;
  margin: 0 5px;
  width: 15px;
  display: none;
}

.kore-chat-window .active.purejscarousel-dot {
  cursor: default;
  opacity: 0.5;
}

.kore-chat-window h1 {
  text-align: center;
}

.kore-chat-window .carousel {
  margin: 50px auto;
  overflow: hidden;
  position: relative;
  width: 240px;
}

.kore-chat-window .carousel:before,
.kore-chat-window .carousel:after {
  content: "";
  display: table;
}

.kore-chat-window .carousel:after {
  clear: both;
}`, "",{"version":3,"sources":["webpack://./src/libs/purejscarousel/purejscarousel.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,6BAAA;EACA,4BAAA;EACA,UAAA;EACA,8BAAA;EACA,iCAAA;EACA,yBAAA;AACF;;AAEA;EACE,6BAAA;EACA,2BAAA;EACA,SAAA;EACA,6BAAA;EACA,gCAAA;EACA,wBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,WAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".kore-chat-window .purejscarousel {\n  overflow: hidden;\n}\n\n.kore-chat-window .purejscarousel-slides-container:before,\n.kore-chat-window .purejscarousel-slides-container:after {\n  content: \"\";\n  display: table;\n}\n\n.kore-chat-window .purejscarousel-slides-container:after {\n  clear: both;\n}\n\n.kore-chat-window .purejscarousel-slide {\n  float: left;\n}\n\n.kore-chat-window .purejscarousel-btn {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  outline: none;\n  cursor: pointer !important;\n  height: 20px;\n  margin-top: -25px;\n  position: absolute;\n  top: 50%;\n  width: 20px;\n}\n\n.kore-chat-window .purejscarousel-btn-next {\n  border-bottom: 8px solid #aaa;\n  border-right: 8px solid #aaa;\n  right: 5px;\n  -moz-transform: rotate(315deg);\n  -webkit-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.kore-chat-window .purejscarousel-btn-prev {\n  border-bottom: 8px solid #aaa;\n  border-left: 8px solid #aaa;\n  left: 5px;\n  -moz-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.kore-chat-window .purejscarousel-dots-container {\n  float: left;\n  margin-top: 15px;\n  text-align: center;\n  width: 100%;\n}\n\n.kore-chat-window .purejscarousel-dot {\n  background: #aaa;\n  border: 0;\n  border-radius: 50%;\n  box-shadow: none;\n  cursor: pointer;\n  height: 15px;\n  outline: none;\n  margin: 0 5px;\n  width: 15px;\n  display: none;\n}\n\n.kore-chat-window .active.purejscarousel-dot {\n  cursor: default;\n  opacity: .5;\n}\n\n.kore-chat-window h1 {\n  text-align: center;\n}\n\n.kore-chat-window .carousel {\n  margin: 50px auto;\n  overflow: hidden;\n  position: relative;\n  width: 240px;\n}\n\n.kore-chat-window .carousel:before,\n.kore-chat-window .carousel:after {\n  content: \"\";\n  display: table;\n}\n\n.kore-chat-window .carousel:after {\n  clear: both;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
